import { render, staticRenderFns } from "./PSFReportTable.vue?vue&type=template&id=eae27ac0&scoped=true&"
import script from "./PSFReportTable.vue?vue&type=script&lang=js&"
export * from "./PSFReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae27ac0",
  null
  
)

export default component.exports